var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("view-page", {
    attrs: {
      title: !_vm.loading ? _vm.selectedList.name : "",
      "permission-name": "list",
      "edit-button": _vm.canEditList,
      "delete-button": false,
      loading: _vm.loading
    },
    on: { editItem: _vm.editList },
    scopedSlots: _vm._u([
      {
        key: "headerRightSide",
        fn: function() {
          return [
            _vm.canCreateNewListItem
              ? _c("management-add-button", {
                  attrs: {
                    label: _vm.$t("AddItem"),
                    "list-missing-permissions": []
                  },
                  on: {
                    buttonClick: function($event) {
                      return _vm.$router.push({
                        name: "list-settings-item-create",
                        params: {
                          listName: _vm.listName,
                          isCustomList: _vm.selectedList.custom_list,
                          list_id: _vm.selectedList.custom_list
                            ? _vm.selectedList.id
                            : null
                        }
                      })
                    }
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "leftSide",
        fn: function() {
          return _vm._l(_vm.fields, function(field) {
            return field.visible
              ? _c("view-page-data-field", {
                  key: field.label,
                  attrs: {
                    icon: field.icon,
                    label: field.label,
                    data: field.data,
                    hasPermission: field.hasPermission
                  }
                })
              : _vm._e()
          })
        },
        proxy: true
      },
      {
        key: "rightSide",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "management-section-wrapper" },
              [
                _c("list-info-data-table", {
                  attrs: {
                    listUuid: _vm.selectedList.uuid,
                    isCustomList: _vm.selectedList.custom_list
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d61f15a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d61f15a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/ListsSettings/ListInfo.vue
// module id = null
// module chunks = 